// extracted by mini-css-extract-plugin
export var scrollArea = "_pb-0";